var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.656,
    height: 47.324,
    viewBox: "0 0 48.656 47.324",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2334",
    "data-name": "Group 2334",
    transform: "translate(-454.5 -6031.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_265",
    "data-name": "Ellipse 265",
    transform: "translate(468.894 6069.861)",
    fill: "none",
    stroke: "#383838",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.605,
    cy: 4.605,
    r: 4.605,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.605,
    cy: 4.605,
    r: 3.105,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_266",
    "data-name": "Ellipse 266",
    transform: "translate(486.394 6069.861)",
    fill: "none",
    stroke: "#383838",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.605,
    cy: 4.605,
    r: 4.605,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.605,
    cy: 4.605,
    r: 3.105,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M-3809-351.752h8.165l1.48,6.6.222,0,30.7-.28s5.735-.764,5.019,5.015-.522,16.058-12.826,16.017-18.841,0-18.841,0l-4.275-20.749",
    transform: "translate(4265 6385)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M-3775.76-321.691s-16.075-.453-18.342,0c-2.074.405-4.466,1.676-3.412,5,0,0,29.679,0,29.679,0",
    transform: "translate(4264.092 6382.657)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.d6381b9f2b9d9d5336691a0b7640833e.svg";
export { ForwardRef as ReactComponent };